import React from 'react';
import OmInputFieldWrapper from '../forms/OmInputFieldWrapper';
import { createActionHandler } from '../../util';
import ResultCard from './ResultCardSection';
import {
    setEmergencyFundOnceOffValue,
    setMonthlyValue,
    calculateEmergencyFund,
} from '@om/redux/actions/investmentCalculator/emergencyFund';

import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    getAmountOnceOffValue,
    getMonthlyAmountValue,
    getCalculateDisabled,
} from '@om/redux/selectors/investmentCalculator/emergencyFundCalculator';
import { getShowRecommendation } from '@om/redux/selectors/investmentCalculator/investmentCalculator';
import { OmInvestmentCalcSection } from '@om/component-library-react';

import TwoColumnImageLeft from '../TwoColumnImageLeft';

const EmergencyFundCalculator = ({ slot, twoColumnImageLeftContent }) => {
    const dispatch = useDispatch();

    const {
        amountOnceOff,
        monthlyAmount,
        calculateButtonDisabled,
        showRecommendation,
    } = useSelector(
        createStructuredSelector({
            amountOnceOff: getAmountOnceOffValue,
            monthlyAmount: getMonthlyAmountValue,
            calculateButtonDisabled: getCalculateDisabled,
            showRecommendation: getShowRecommendation,
        }),
    );

    return (
        <OmInvestmentCalcSection slot={slot}>
            <div slot='form-content'>
                <h4>Invest for an Emergency Fund</h4>
                <h6 className='no-bottom-margin'>
                    How much do you want to invest once-off?
                </h6>
                <OmInputFieldWrapper
                    isSensitive={true}
                    preset='KES'
                    prefixString='KES'
                    required={true}
                    size='full'
                    formId='EmergencyFundCalculatorForm'
                    name='amountOnceOff'
                    mask='thousands-spaced'
                    keyboardMode='numeric'
                    hintText=''
                    reduxValue={amountOnceOff}
                    persistHandler={createActionHandler(
                        dispatch,
                        setEmergencyFundOnceOffValue,
                    )}
                />
                <h6 className='no-bottom-margin'>
                    How much do you want to save monthly?
                </h6>
                <OmInputFieldWrapper
                    isSensitive={true}
                    preset='KES'
                    prefixString='KES'
                    required={true}
                    size='full'
                    formId='EmergencyFundCalculatorForm'
                    name='amountMonthly'
                    mask='thousands-spaced'
                    keyboardMode='numeric'
                    hintText=''
                    align='left'
                    reduxValue={monthlyAmount}
                    persistHandler={createActionHandler(
                        dispatch,
                        setMonthlyValue,
                    )}
                />
                <h6 className='no-bottom-margin'>
                    Please note that this is non-contractual
                </h6>
            </div>
            <ResultCard
                calculateButtonDisabled={calculateButtonDisabled}
                setInvestmentResult={() => dispatch(calculateEmergencyFund())}
            />

            <div slot='product-offering'>
                {showRecommendation && (
                    <>
                        <TwoColumnImageLeft
                            twoColumnImageLeftContent={
                                twoColumnImageLeftContent
                            }
                        />
                    </>
                )}
            </div>
        </OmInvestmentCalcSection>
    );
};

export default EmergencyFundCalculator;
